import jQuery from "jquery";
import DATA from "../data/data";
import SERVICE_REGISTRY from "../services/registry";
import { SETTINGS } from "../settings";
import templates from "../templates";
import MapView from "./mapView";
import SidePanel from "./sidePanel";
const $ = jQuery;
/**
 * storeId : for detail map only, id of the only store to display on the map for Total detail web page
 * mobileDetailMapDisplay : for detail map only, hide button to display direction. Use for mobile detail map
 */

export default class MainView {
    constructor(
        container,
        brands,
        country,
        filters,
        language,
        mapSearchQuery,
        storeId,
        mobileDetailMapDisplay,
        autocompleteByName,
        business,
    ) {
        const selector = ".storemap-store-locator";

        container.innerHTML = templates.desktop.main.render({
            ui: total.maps.L10n.ui,
            itinerary: SETTINGS.itinerary,
        });

        document
            .querySelector(selector)
            .insertAdjacentHTML("beforeend", templates.common.filterModal.render({ ui: total.maps.L10n.ui }));
        document.querySelector(selector).insertAdjacentHTML("afterbegin", MapView.render());
        $(selector).find("#wm-modal--filters-list").append(SERVICE_REGISTRY.filterService.getTemplate()[0].innerHTML);
        this.mapView = new MapView(country, storeId, mapSearchQuery, this);
        let sidePanel;
        if (mapSearchQuery) {
            // Not sure about formatedString so not remove if for now
            // eslint-disable-next-line no-unused-vars
            DATA.woosGeocode(mapSearchQuery, (bounds, location, formatedString) => {
                sidePanel = new SidePanel(
                    this.mapView,
                    language,
                    storeId,
                    mobileDetailMapDisplay,
                    autocompleteByName,
                    business,
                    location,
                    mapSearchQuery,
                );
                this.initEvent(this.mapView, sidePanel);
            });
        } else {
            sidePanel = new SidePanel(
                this.mapView,
                language,
                storeId,
                mobileDetailMapDisplay,
                autocompleteByName,
                business,
            );

            this.initEvent(this.mapView, sidePanel);
        }

        this.toggleDirectionView = function toggleDirectionView() {
            sidePanel.toggleDirectionView();
        };
        this.setStoreSelectedFromMap = (state) => {
            sidePanel.setStoreSelectedFromMap(state);
        };
    }

    initEvent(mapView, sidePanel) {
        SERVICE_REGISTRY.storeService.onItinaryStoresChange((stores) => {
            mapView.onItinaryStoresChange(stores);
            sidePanel.onItinaryStoresChange(stores);
        });

        mapView.onCenterChange(() => {
            sidePanel.onCenterChange();
        });

        SERVICE_REGISTRY.filterService.onQueryFilterChange((tags, types) => {
            mapView.onQueryFilterChange(tags, types);
            sidePanel.onQueryFilterChange();
        });

        SERVICE_REGISTRY.storeService.onSelectedStoreChange((store, centerOnStore) => {
            mapView.onSelectedStoreChanged(store, centerOnStore);
            sidePanel.onSelectedStoreChange(store);
        });

        SERVICE_REGISTRY.storeService.onSelectedStoreReset(() => {
            mapView.onSelectedStoreReset();
        });

        SERVICE_REGISTRY.storeService.onNearbyStoresChange((stores) => {
            // mapView.onNearbyStoresChange(stores);
            sidePanel.onNearbyStoresChange(stores);
        });

        SERVICE_REGISTRY.storeService.onUniqueStoreChange((store) => {
            mapView.onUniqueStoreChange(store);
            sidePanel.onUniqueStoreChange(store);
            mapView.onSelectedStoreChanged(store);
        });

        SERVICE_REGISTRY.locationService.onLocationChange((location, blockSearchNearbyStores) => {
            mapView.onLocationChange(location);
            if (!blockSearchNearbyStores) {
                SERVICE_REGISTRY.storeService.setLocation(location);
            }
        });

        SERVICE_REGISTRY.locationService.onLocationReset(() => {
            mapView.onLocationReset();
            sidePanel.onLocationReset();
        });

        SERVICE_REGISTRY.storeService.onStoreForDetailChange((store) => {
            sidePanel.onStoreForDetailChange(store);
        });

        SERVICE_REGISTRY.storeService.onStoresReset(() => {
            mapView.onStoresReset();
            sidePanel.onStoresReset();
        });
    }
}
